import { render, staticRenderFns } from "./functionSon.vue?vue&type=template&id=539122ae&scoped=true&"
import script from "./functionSon.vue?vue&type=script&lang=js&"
export * from "./functionSon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539122ae",
  null
  
)

export default component.exports